// PC版　年度
$("#pc-year")
  .on("click", ".year-placeholder", function () {
    const parent = $(this).closest("#pc-year");
    parent.attr("tabindex", 1).focus();
    if (!parent.hasClass("is-open")) {
      parent.toggleClass("is-open");
      $("#pc-year.is-open").not(parent).removeClass("is-open");
    } else {
      parent.removeClass("is-open");
    }
  })
  .on("click", ".year-list>.year-list_item", function () {
    const parent = $(this).closest("#pc-year");
    parent
      .removeClass("is-open")
      .find(".year-placeholder")
      .text($(this).text());
    parent.find("input[type=hidden]").attr("value", $(this).attr("data-value"));
  })
  .focusout(function () {
    $(this).removeClass("is-open");
  });

// SP版　年度
$("#sp-year")
  .on("click", ".year-placeholder", function () {
    const parent = $(this).closest("#sp-year");
    parent.attr("tabindex", 1).focus();
    if (!parent.hasClass("is-open")) {
      parent.toggleClass("is-open");
      $("#sp-year.is-open").not(parent).removeClass("is-open");
    } else {
      parent.removeClass("is-open");
    }
  })
  .on("click", ".year-list>.year-list_item", function () {
    const parent = $(this).closest("#sp-year");
    parent
      .removeClass("is-open")
      .find(".year-placeholder")
      .text($(this).text());
    parent.find("input[type=hidden]").attr("value", $(this).attr("data-value"));
  })
  .focusout(function () {
    $(this).removeClass("is-open");
  });
